export default __webpack_public_path__ + "static/media/wallet.6da72b77.svg";